// Comprehensive list of all international country codes
export const COUNTRY_CODE_MAP: Record<string, string> = {
  // North America
  '+1': '+1',
  '1': '+1', // USA, Canada

  // Europe
  '+7': '+7',
  '7': '+7', // Russia, Kazakhstan
  '+30': '+30',
  '30': '+30', // Greece
  '+31': '+31',
  '31': '+31', // Netherlands
  '+32': '+32',
  '32': '+32', // Belgium
  '+33': '+33',
  '33': '+33', // France
  '+34': '+34',
  '34': '+34', // Spain
  '+36': '+36',
  '36': '+36', // Hungary
  '+39': '+39',
  '39': '+39', // Italy
  '+40': '+40',
  '40': '+40', // Romania
  '+41': '+41',
  '41': '+41', // Switzerland
  '+43': '+43',
  '43': '+43', // Austria
  '+44': '+44',
  '44': '+44', // UK
  '+45': '+45',
  '45': '+45', // Denmark
  '+46': '+46',
  '46': '+46', // Sweden
  '+47': '+47',
  '47': '+47', // Norway
  '+48': '+48',
  '48': '+48', // Poland
  '+49': '+49',
  '49': '+49', // Germany
  '+351': '+351',
  '351': '+351', // Portugal
  '+352': '+352',
  '352': '+352', // Luxembourg
  '+353': '+353',
  '353': '+353', // Ireland
  '+354': '+354',
  '354': '+354', // Iceland
  '+355': '+355',
  '355': '+355', // Albania
  '+356': '+356',
  '356': '+356', // Malta
  '+357': '+357',
  '357': '+357', // Cyprus
  '+358': '+358',
  '358': '+358', // Finland
  '+359': '+359',
  '359': '+359', // Bulgaria
  '+370': '+370',
  '370': '+370', // Lithuania
  '+371': '+371',
  '371': '+371', // Latvia
  '+372': '+372',
  '372': '+372', // Estonia
  '+373': '+373',
  '373': '+373', // Moldova
  '+374': '+374',
  '374': '+374', // Armenia
  '+375': '+375',
  '375': '+375', // Belarus
  '+376': '+376',
  '376': '+376', // Andorra
  '+377': '+377',
  '377': '+377', // Monaco
  '+378': '+378',
  '378': '+378', // San Marino
  '+380': '+380',
  '380': '+380', // Ukraine
  '+381': '+381',
  '381': '+381', // Serbia
  '+382': '+382',
  '382': '+382', // Montenegro
  '+383': '+383',
  '383': '+383', // Kosovo
  '+385': '+385',
  '385': '+385', // Croatia
  '+386': '+386',
  '386': '+386', // Slovenia
  '+387': '+387',
  '387': '+387', // Bosnia and Herzegovina
  '+389': '+389',
  '389': '+389', // North Macedonia
  '+420': '+420',
  '420': '+420', // Czech Republic
  '+421': '+421',
  '421': '+421', // Slovakia
  '+423': '+423',
  '423': '+423', // Liechtenstein

  // South America
  '+51': '+51',
  '51': '+51', // Peru
  '+52': '+52',
  '52': '+52', // Mexico
  '+53': '+53',
  '53': '+53', // Cuba
  '+54': '+54',
  '54': '+54', // Argentina
  '+55': '+55',
  '55': '+55', // Brazil
  '+56': '+56',
  '56': '+56', // Chile
  '+57': '+57',
  '57': '+57', // Colombia
  '+58': '+58',
  '58': '+58', // Venezuela
  '+591': '+591',
  '591': '+591', // Bolivia
  '+592': '+592',
  '592': '+592', // Guyana
  '+593': '+593',
  '593': '+593', // Ecuador
  '+594': '+594',
  '594': '+594', // French Guiana
  '+595': '+595',
  '595': '+595', // Paraguay
  '+596': '+596',
  '596': '+596', // Martinique
  '+597': '+597',
  '597': '+597', // Suriname
  '+598': '+598',
  '598': '+598', // Uruguay
  '+599': '+599',
  '599': '+599', // Curaçao

  // Central America & Caribbean
  '+501': '+501',
  '501': '+501', // Belize
  '+502': '+502',
  '502': '+502', // Guatemala
  '+503': '+503',
  '503': '+503', // El Salvador
  '+504': '+504',
  '504': '+504', // Honduras
  '+505': '+505',
  '505': '+505', // Nicaragua
  '+506': '+506',
  '506': '+506', // Costa Rica
  '+507': '+507',
  '507': '+507', // Panama
  '+509': '+509',
  '509': '+509', // Haiti
  '+590': '+590',
  '590': '+590', // Guadeloupe

  // Asia
  '+60': '+60',
  '60': '+60', // Malaysia
  '+61': '+61',
  '61': '+61', // Australia
  '+62': '+62',
  '62': '+62', // Indonesia
  '+63': '+63',
  '63': '+63', // Philippines
  '+64': '+64',
  '64': '+64', // New Zealand
  '+65': '+65',
  '65': '+65', // Singapore
  '+66': '+66',
  '66': '+66', // Thailand
  '+81': '+81',
  '81': '+81', // Japan
  '+82': '+82',
  '82': '+82', // South Korea
  '+84': '+84',
  '84': '+84', // Vietnam
  '+86': '+86',
  '86': '+86', // China
  '+90': '+90',
  '90': '+90', // Turkey
  '+91': '+91',
  '91': '+91', // India
  '+92': '+92',
  '92': '+92', // Pakistan
  '+93': '+93',
  '93': '+93', // Afghanistan
  '+94': '+94',
  '94': '+94', // Sri Lanka
  '+95': '+95',
  '95': '+95', // Myanmar
  '+98': '+98',
  '98': '+98', // Iran
  '+850': '+850',
  '850': '+850', // North Korea
  '+852': '+852',
  '852': '+852', // Hong Kong
  '+853': '+853',
  '853': '+853', // Macau
  '+855': '+855',
  '855': '+855', // Cambodia
  '+856': '+856',
  '856': '+856', // Laos
  '+880': '+880',
  '880': '+880', // Bangladesh
  '+886': '+886',
  '886': '+886', // Taiwan
  '+960': '+960',
  '960': '+960', // Maldives
  '+975': '+975',
  '975': '+975', // Bhutan
  '+976': '+976',
  '976': '+976', // Mongolia
  '+977': '+977',
  '977': '+977', // Nepal
  '+992': '+992',
  '992': '+992', // Tajikistan
  '+993': '+993',
  '993': '+993', // Turkmenistan
  '+994': '+994',
  '994': '+994', // Azerbaijan
  '+995': '+995',
  '995': '+995', // Georgia
  '+996': '+996',
  '996': '+996', // Kyrgyzstan
  '+998': '+998',
  '998': '+998', // Uzbekistan

  // Middle East
  '+961': '+961',
  '961': '+961', // Lebanon
  '+962': '+962',
  '962': '+962', // Jordan
  '+963': '+963',
  '963': '+963', // Syria
  '+964': '+964',
  '964': '+964', // Iraq
  '+965': '+965',
  '965': '+965', // Kuwait
  '+966': '+966',
  '966': '+966', // Saudi Arabia
  '+967': '+967',
  '967': '+967', // Yemen
  '+968': '+968',
  '968': '+968', // Oman
  '+970': '+970',
  '970': '+970', // Palestine
  '+971': '+971',
  '971': '+971', // UAE
  '+972': '+972',
  '972': '+972', // Israel
  '+973': '+973',
  '973': '+973', // Bahrain
  '+974': '+974',
  '974': '+974', // Qatar

  // Africa
  '+20': '+20',
  '20': '+20', // Egypt
  '+27': '+27',
  '27': '+27', // South Africa
  '+212': '+212',
  '212': '+212', // Morocco
  '+213': '+213',
  '213': '+213', // Algeria
  '+216': '+216',
  '216': '+216', // Tunisia
  '+218': '+218',
  '218': '+218', // Libya
  '+220': '+220',
  '220': '+220', // Gambia
  '+221': '+221',
  '221': '+221', // Senegal
  '+222': '+222',
  '222': '+222', // Mauritania
  '+223': '+223',
  '223': '+223', // Mali
  '+224': '+224',
  '224': '+224', // Guinea
  '+225': '+225',
  '225': '+225', // Ivory Coast
  '+226': '+226',
  '226': '+226', // Burkina Faso
  '+227': '+227',
  '227': '+227', // Niger
  '+228': '+228',
  '228': '+228', // Togo
  '+229': '+229',
  '229': '+229', // Benin
  '+230': '+230',
  '230': '+230', // Mauritius
  '+231': '+231',
  '231': '+231', // Liberia
  '+232': '+232',
  '232': '+232', // Sierra Leone
  '+233': '+233',
  '233': '+233', // Ghana
  '+234': '+234',
  '234': '+234', // Nigeria
  '+235': '+235',
  '235': '+235', // Chad
  '+236': '+236',
  '236': '+236', // Central African Republic
  '+237': '+237',
  '237': '+237', // Cameroon
  '+238': '+238',
  '238': '+238', // Cape Verde
  '+239': '+239',
  '239': '+239', // São Tomé and Príncipe
  '+240': '+240',
  '240': '+240', // Equatorial Guinea
  '+241': '+241',
  '241': '+241', // Gabon
  '+242': '+242',
  '242': '+242', // Republic of the Congo
  '+243': '+243',
  '243': '+243', // Democratic Republic of the Congo
  '+244': '+244',
  '244': '+244', // Angola
  '+245': '+245',
  '245': '+245', // Guinea-Bissau
  '+248': '+248',
  '248': '+248', // Seychelles
  '+249': '+249',
  '249': '+249', // Sudan
  '+250': '+250',
  '250': '+250', // Rwanda
  '+251': '+251',
  '251': '+251', // Ethiopia
  '+252': '+252',
  '252': '+252', // Somalia
  '+253': '+253',
  '253': '+253', // Djibouti
  '+254': '+254',
  '254': '+254', // Kenya
  '+255': '+255',
  '255': '+255', // Tanzania
  '+256': '+256',
  '256': '+256', // Uganda
  '+257': '+257',
  '257': '+257', // Burundi
  '+258': '+258',
  '258': '+258', // Mozambique
  '+260': '+260',
  '260': '+260', // Zambia
  '+261': '+261',
  '261': '+261', // Madagascar
  '+262': '+262',
  '262': '+262', // Réunion
  '+263': '+263',
  '263': '+263', // Zimbabwe
  '+264': '+264',
  '264': '+264', // Namibia
  '+265': '+265',
  '265': '+265', // Malawi
  '+266': '+266',
  '266': '+266', // Lesotho
  '+267': '+267',
  '267': '+267', // Botswana
  '+268': '+268',
  '268': '+268', // Eswatini
  '+269': '+269',
  '269': '+269', // Comoros
  '+291': '+291',
  '291': '+291', // Eritrea

  // Pacific
  '+670': '+670',
  '670': '+670', // East Timor
  '+673': '+673',
  '673': '+673', // Brunei
  '+674': '+674',
  '674': '+674', // Nauru
  '+675': '+675',
  '675': '+675', // Papua New Guinea
  '+676': '+676',
  '676': '+676', // Tonga
  '+677': '+677',
  '677': '+677', // Solomon Islands
  '+678': '+678',
  '678': '+678', // Vanuatu
  '+679': '+679',
  '679': '+679', // Fiji
  '+680': '+680',
  '680': '+680', // Palau
  '+681': '+681',
  '681': '+681', // Wallis and Futuna
  '+682': '+682',
  '682': '+682', // Cook Islands
  '+683': '+683',
  '683': '+683', // Niue
  '+684': '+684',
  '684': '+684', // American Samoa
  '+685': '+685',
  '685': '+685', // Samoa
  '+686': '+686',
  '686': '+686', // Kiribati
  '+687': '+687',
  '687': '+687', // New Caledonia
  '+688': '+688',
  '688': '+688', // Tuvalu
  '+689': '+689',
  '689': '+689', // French Polynesia
  '+690': '+690',
  '690': '+690', // Tokelau
  '+691': '+691',
  '691': '+691', // Micronesia
  '+692': '+692',
  '692': '+692', // Marshall Islands
};

const DEFAULT_COUNTRY_CODE = '+91';
const DEFAULT_MOBILE_PREFIXES = ['6', '7', '8', '9'];

/**
 * Parse phone number and extract country code
 * @param value - Phone number string (with or without country code)
 * @returns Object with country code and phone number (empty strings if no match)
 */
export function parsePhoneNumber(value: string): { countryCode: string; phoneNumber: string } {
  if (!value) {
    return {
      countryCode: '',
      phoneNumber: '',
    };
  }

  let cleaned = value.replace(/\s+/g, '').replace(/[^\d+]/g, '');

  // Normalize numbers starting with international dialling prefix (00)
  if (!cleaned.startsWith('+') && cleaned.startsWith('00')) {
    cleaned = `+${cleaned.substring(2)}`;
  }

  const limitDigits = (input: string) => input.replace(/\D/g, '').substring(0, 15);
  const digitsOnly = limitDigits(cleaned);

  if (!digitsOnly) {
    return {
      countryCode: '',
      phoneNumber: '',
    };
  }

  const digitsWithoutLeadingZero = digitsOnly.startsWith('0') ? digitsOnly.substring(1) : digitsOnly;

  if (cleaned.startsWith('+')) {
    const sortedCodes = Object.keys(COUNTRY_CODE_MAP)
      .filter((code) => code.startsWith('+'))
      .sort((a, b) => b.length - a.length);

    for (const code of sortedCodes) {
      if (cleaned.startsWith(code)) {
        return {
          countryCode: COUNTRY_CODE_MAP[code],
          phoneNumber: limitDigits(cleaned.substring(code.length)),
        };
      }
    }

    return {
      countryCode: '',
      phoneNumber: limitDigits(cleaned.substring(1)),
    };
  }

  const priorityCodes = ['94'];
  for (const code of priorityCodes) {
    if (digitsOnly.startsWith(code)) {
      return {
        countryCode: COUNTRY_CODE_MAP[code],
        phoneNumber: limitDigits(digitsOnly.substring(code.length)),
      };
    }

    if (digitsWithoutLeadingZero.startsWith(code)) {
      return {
        countryCode: COUNTRY_CODE_MAP[code],
        phoneNumber: limitDigits(digitsWithoutLeadingZero.substring(code.length)),
      };
    }
  }

  const firstDigit = digitsWithoutLeadingZero.charAt(0);

  if (
    digitsOnly.length <= 11 &&
    digitsWithoutLeadingZero.length === 10 &&
    DEFAULT_MOBILE_PREFIXES.includes(firstDigit)
  ) {
    return {
      countryCode: DEFAULT_COUNTRY_CODE,
      phoneNumber: limitDigits(digitsWithoutLeadingZero),
    };
  }

  const sortedCodes = Object.keys(COUNTRY_CODE_MAP)
    .filter((code) => !code.startsWith('+'))
    .sort((a, b) => b.length - a.length);

  const tryMatch = (input: string) => {
    for (const code of sortedCodes) {
      const remainingLength = input.length - code.length;
      if (remainingLength < 0) continue;

      if (code.length === 1 && remainingLength < 10) {
        continue;
      }

      if (input.startsWith(code)) {
        return {
          countryCode: COUNTRY_CODE_MAP[code],
          phoneNumber: limitDigits(input.substring(code.length)),
        };
      }
    }
    return null;
  };

  const matchWithoutZero = tryMatch(digitsWithoutLeadingZero);
  if (matchWithoutZero) {
    return matchWithoutZero;
  }

  const matchWithDigits = tryMatch(digitsOnly);
  if (matchWithDigits) {
    return matchWithDigits;
  }

  return {
    countryCode: '',
    phoneNumber: limitDigits(digitsWithoutLeadingZero || digitsOnly),
  };
}

export function normalizePhoneForStorage(countryCode: string, phoneNumber: string): string {
  const rawDigits = (phoneNumber || '').replace(/\D/g, '');

  if (!rawDigits) {
    return '';
  }

  let trimmedCountry = (countryCode || '').replace(/\D/g, '');

  if (!trimmedCountry && rawDigits.length === 10 && DEFAULT_MOBILE_PREFIXES.includes(rawDigits.charAt(0))) {
    trimmedCountry = DEFAULT_COUNTRY_CODE.replace(/\D/g, '');
  }

  const maxSubscriberDigits = Math.max(0, 15 - (trimmedCountry ? trimmedCountry.length : 0));

  if (maxSubscriberDigits === 0) {
    // Cannot append subscriber digits without exceeding limits; treat as invalid
    return trimmedCountry ? `+${trimmedCountry}` : '';
  }

  const subscriberDigits = rawDigits.substring(0, maxSubscriberDigits);

  if (!subscriberDigits) {
    return '';
  }

  return trimmedCountry ? `+${trimmedCountry}${subscriberDigits}` : subscriberDigits;
}

export interface WhatsAppPhoneResult {
  countryCode: string;
  phoneNumber: string;
  whatsappNumber: string | null;
  normalizedForStorage: string;
  rawDigits: string;
  isValid: boolean;
  error?: string;
}

interface PreparePhoneOptions {
  fallbackCountryCode?: string;
}

export function preparePhoneForWhatsApp(
  value: string,
  options: PreparePhoneOptions = {},
): WhatsAppPhoneResult {
  const fallbackCountry = (options.fallbackCountryCode || DEFAULT_COUNTRY_CODE).replace(/\D/g, '');
  const input = (value || '').trim();
  const rawDigits = input.replace(/\D/g, '');

  const parsed = parsePhoneNumber(input);
  let resolvedCountryCode = parsed.countryCode || '';
  let resolvedPhoneNumber = (parsed.phoneNumber || '').replace(/\D/g, '');

  // Attempt to infer default country code for common local Indian numbers
  if (
    !resolvedCountryCode &&
    resolvedPhoneNumber.length === 10 &&
    DEFAULT_MOBILE_PREFIXES.includes(resolvedPhoneNumber.charAt(0))
  ) {
    resolvedCountryCode = `+${fallbackCountry}`;
  }

  if (!resolvedPhoneNumber && rawDigits) {
    resolvedPhoneNumber = rawDigits;
  }

  const sanitizedCountryDigits = (resolvedCountryCode || '').replace(/\D/g, '');

  if (!sanitizedCountryDigits) {
    return {
      countryCode: resolvedCountryCode,
      phoneNumber: resolvedPhoneNumber,
      whatsappNumber: null,
      normalizedForStorage: '',
      rawDigits,
      isValid: false,
      error: 'Phone number must include an international country code (e.g., +91).',
    };
  }

  if (!resolvedPhoneNumber) {
    return {
      countryCode: resolvedCountryCode,
      phoneNumber: resolvedPhoneNumber,
      whatsappNumber: null,
      normalizedForStorage: '',
      rawDigits,
      isValid: false,
      error: 'Phone number is missing digits.',
    };
  }

  const whatsappNumber = `${sanitizedCountryDigits}${resolvedPhoneNumber}`.replace(/\D/g, '');
  const isValidLength = whatsappNumber.length >= 7 && whatsappNumber.length <= 15;

  if (!isValidLength) {
    return {
      countryCode: resolvedCountryCode,
      phoneNumber: resolvedPhoneNumber,
      whatsappNumber: null,
      normalizedForStorage: '',
      rawDigits,
      isValid: false,
      error: 'Phone number must be between 7 and 15 digits after including the country code.',
    };
  }

  const normalizedForStorage = normalizePhoneForStorage(resolvedCountryCode, resolvedPhoneNumber);

  return {
    countryCode: resolvedCountryCode,
    phoneNumber: resolvedPhoneNumber,
    whatsappNumber,
    normalizedForStorage,
    rawDigits,
    isValid: true,
  };
}

/**
 * Validate phone number length
 * @param phoneNumber - Phone number to validate
 * @returns true if valid length (7-15 digits)
 */
export function isValidPhoneLength(phoneNumber: string, countryCode?: string): boolean {
  const totalDigits = `${countryCode || ''}${phoneNumber || ''}`.replace(/\D/g, '');
  const length = totalDigits.length;
  return length >= 7 && length <= 15;
}
